module.exports = __webpack_public_path__ + "static/media/42.4a2c9b94.jpg";